export enum BRAZE_CONTENT_CARD {
  PATIENT_HOME = 'patient_home',
  PATIENT_CONSULTATIONS = 'patient_consultations',
  PATIENT_MEDICINE_INFORMATION = 'patient_medicine_information',
  PATIENT_PRESCRIPTIONS = 'patient_prescriptions',
}
